module.exports = __webpack_public_path__ + "static/media/arrow_circle_bottom.c421cb32.svg";